module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$root.hideNavigation) ? _c('ul', {
    class: ['vue-nav']
  }, [_vm._l((_vm.menu), function(mItem, menuIndex) {
    return [_c('li', {
      class: mItem.route && _vm.$route.name == mItem.route.name ? ['current'] : ''
    }, [_c('router-link', {
      attrs: {
        "to": mItem.route ? mItem.route : {
          name: _vm.$route.name,
          params: _vm.$route.params
        }
      },
      domProps: {
        "textContent": _vm._s((menuIndex + 1) + '. ' + mItem.text)
      }
    })], 1)]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vue-rqf bg-loading",
    attrs: {
      "loading": _vm.$root.ui.loading
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e903452"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Opq/Index.vue
// module id = 117
// module chunks = 0